type StepHeaderProps = {
  title: string;
  description: string;
};

export function StepHeader({ title, description }: StepHeaderProps) {
  return (
    <header className="tw:space-y-3">
      <h1 className="tw:text-xl tw:font-semibold tw:tracking-tight tw:text-foreground">
        {title}
      </h1>
      <p className="tw:max-w-3xl tw:text-md tw:text-muted-foreground">
        {description}
      </p>
    </header>
  );
}
